import { render } from "./CvPreview.vue?vue&type=template&id=58f37c60&scoped=true"
import script from "./CvPreview.vue?vue&type=script&lang=js"
export * from "./CvPreview.vue?vue&type=script&lang=js"

import "./CvPreview.vue?vue&type=style&index=0&id=58f37c60&scoped=true&lang=css"

import exportComponent from "/var/www/matchmaker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58f37c60"]])

export default __exports__